module.exports = "pegasus_template/assets/web_template/location.png";